import { CurrencyInput } from '@/components/ui/currency-input';
import { centsToInitialValue, currencyInputValueToCents } from '@/lib/currency';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleAppraisedValueEditor = ({
  tradeId,
  initialAppraisedValue,
}: {
  tradeId: Trade['id'];
  initialAppraisedValue: number;
}) => {
  const [appraisedValue, setAppraisedValue] = useState(initialAppraisedValue);

  const updateAppraisedValueMutation = useMutation({
    onMutate: async ({ appraisedValue }: { appraisedValue: number }) => {
      tradesStore.updateTrade(tradeId, {
        appraised_value: appraisedValue,
      });
    },
    mutationFn: async ({ appraisedValue }: { appraisedValue: number }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/appraised_value`,
        // /api/trades/:trade_id/appraised_value
        {
          appraised_value: appraisedValue,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating appraised value', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleAppraisedValueChange = useCallback(
    debounce((newAppraisedValue: number) => {
      // toast({
      //   title: 'Mileage change not implemented',
      //   description: `Mileage change is not implemented yet. ${newMileage}`,
      // });
      updateAppraisedValueMutation.mutate({
        appraisedValue: newAppraisedValue,
      });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (appraisedValue === initialAppraisedValue) return;

    handleAppraisedValueChange(appraisedValue);
  }, [appraisedValue]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) return;

    setAppraisedValue(currencyInputValueToCents(e.target.value));
  }, []);

  useEffect(() => {
    setAppraisedValue(initialAppraisedValue);
  }, [initialAppraisedValue]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Appraised Value
        </div>
      </div>
      <CurrencyInput
        className="rounded text-xs text-right"
        placeholder="Add Appraised Value"
        value={centsToInitialValue(appraisedValue)}
        onChange={onChange}
      />
    </div>
  );
};

export default TradeVehicleAppraisedValueEditor;
